import axios from "axios";
import Cookies from "js-cookie";


const baseUrl = process.env.REACT_APP_API_URL;
export default async function PostByAgg(props){
    try {
      const response = await axios.post(baseUrl + props.url, props.body);

      if (response && response.data && response.data.data !== null && response.data.data !== undefined) {
          props.onResponse(response);
      } else {
          response.data.data = [];
          props.onResponse(response);
      }
    } catch (error) {
        if (error.response && error.response.data) {
            console.log("Error Response dari axios.js: ", error.response.data);
            props.onError(error);
        } else {
            console.log("Error noResponse: ", error);
            props.onError(error);
        }
    }
  }

  export async function PostFormDataByAgg(props) {
    try {
      const response = await axios.post(baseUrl + props.url, props.body, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });
  
      if (response && response.data && response.data.data !== null && response.data.data !== undefined) {
        props.onResponse(response);
      } else {
        response.data.data = [];
        props.onResponse(response);
      }
    } catch (error) {
      if (error.response && error.response.data) {
        console.log("Error Response (multipart):", error.response.data);
        props.onError(error);
      } else {
        console.log("Error noResponse (multipart):", error);
        props.onError(error);
      }
    }
  }

//  export const downloadFileFromApi = async (props) => {
//   const { url, body, fileName, onResponse, onError } = props;

//   try {
//     const response = await axios.post(baseUrl + url, body, {
//       headers: {
//         'Content-Type': 'application/json',
//       },
//       responseType: 'blob',
//     });

//     if (response && response.data instanceof Blob) {
//       const downloadUrl = window.URL.createObjectURL(response.data);

//       const a = document.createElement('a');
//       a.href = downloadUrl;
//       a.download = fileName || 'file.zip'; 
//       document.body.appendChild(a);
//       a.click(); 
//       a.remove();

//       window.URL.revokeObjectURL(downloadUrl);
//       onResponse(response); 
//     } else {
//       throw new Error('Data tidak valid untuk diunduh');
//     }
//   } catch (error) {
//     console.error("Error Response:", error.response ? error.response.data : error.message);
//     onError(error);
//   }
// };

export const downloadFileFromApi = async (props) => {
  const { url, body, fileName, onResponse, onError, headers: extraHeaders } = props;

  try {
    const response = await axios.post(baseUrl + url, body, {
      headers: { 'Content-Type': 'application/json', ...(extraHeaders || {}) },
      responseType: 'blob',
    });

    // Tentukan nama file dari Content-Disposition; jika tidak ada, pakai fileName fallback
    let filename = fileName || 'payment-export.xlsx';
    const cd = response.headers['content-disposition'] || response.headers['Content-Disposition'];
    if (cd) {
      const m1 = /filename\*=UTF-8''([^;]+)/i.exec(cd);
      const m2 = /filename="?([^";]+)"?/i.exec(cd);
      const raw = (m1 && m1[1]) || (m2 && m2[1]);
      if (raw) filename = decodeURIComponent(raw);
    }

    // Trigger download
    const blob = new Blob([response.data], {
      type: response.headers['content-type'] || 'application/octet-stream',
    });
    const downloadUrl = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = downloadUrl;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    a.remove();
    window.URL.revokeObjectURL(downloadUrl);

    onResponse && onResponse(response);
  } catch (error) {
    console.error("Error Response:", error.response ? error.response.data : error.message);
    onError && onError(error);
  }
};
  

export async function PostByAggWithAuth(props){
    try {
      const storedEmail = Cookies.get("email");
      const storedRole = Cookies.get("roleCode");
      const musicLabelCode = Cookies.get("musicLabelCode");
      console.log({storedEmail,storedRole,musicLabelCode})
      
      const response = await axios.post(baseUrl + props.url, props.body, {
        headers: {
          'X-User-Email': storedEmail,
          'X-User-Role': storedRole,
          'X-User-Label': musicLabelCode,
        }
      });

      if (response && response.data && response.data.data !== null && response.data.data !== undefined) {
          props.onResponse(response);
      } else {
          response.data.data = [];
          props.onResponse(response);
      }
    } catch (error) {
        if (error.response && error.response.data) {
            console.log("Error Response dari axios.js: ", error.response.data);
            props.onError(error);
        } else {
            console.log("Error noResponse: ", error);
            props.onError(error);
        }
    }
};